import http from "./http";
let baseUrl = "/finance-web";
/**
 * 获取项目部列表
 * */
const getDeptListService = () => {
    return new Promise((resolve, reject) => {
        http.get("/contract-web/project/queryAllProjectDeptWithAuth", {}, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 查询工程事前成本列表
 * */
const getBefireListService = (params) => {
    return new Promise((resolve, reject) => {
        http.get("/contract-web/project/front/project/list", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 查询细目列表
 * */
const queryDetailDataService = (params) => {
    return new Promise((resolve, reject) => {
        http.get("/contract-web/project/common/queryDetailData", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/**
 * 新增事前成本细目
 * */
const beforFrontItemService = (params) => {
    return new Promise((resolve, reject) => {
        http.post("/contract-web/project/front/items", params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/**
 * 查询事前成本子目详情
 * */
const queryFrontDetailService = (params) => {
    return new Promise((resolve, reject) => {
        http.get("/contract-web/project/front/detail", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 批量删除事中工程量清单细目
 * */
const batchDeleteFrontDataService = (params) => {
    return new Promise((resolve, reject) => {
        http.post("/contract-web/project/front/batchDeleteFrontData", params,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 删除事前成本细目
 * */
const deleteFrontItemsService = (params) => {
    return new Promise((resolve, reject) => {
        http.delete("/contract-web/project/front/items", params).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/**
 * 更新事前成本细目
 * */
const saveFrontService = (params) => {
    return new Promise((resolve, reject) => {
        http.put("/contract-web/project/front", params).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 更新全部事前成本细目
 * */
const saveFrontBatchService = (params) => {
    return new Promise((resolve, reject) => {
        http.put("/contract-web/project/front/updateFrontBatch", params).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/**
 * 查询事前成本历史列表
 * */
const getFrontHistroyService = (params) => {
    return new Promise((resolve, reject) => {
        http.get("/contract-web/project/front/histroy/list", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/**
 * 查询事前成本历史列表
 * */
const queryApproveProcessService = (params) => {
    return new Promise((resolve, reject) => {
        http.get("/common-web/approve/queryApproveProcess", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 查询事中成本审核列表
 * */
const queryMiddleAuditListService = (params) => {
    return new Promise((resolve, reject) => {
        http.get("/contract-web/project/middle/audit/list", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 创建审批流
 * */
const createApproveProcessService = (params) => {
    return new Promise((resolve, reject) => {
        http.post("/common-web/approve/createApproveProcess", params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 批量创建审批流
 * */
const batchCreateApproveProcessService = (params) => {
    return new Promise((resolve, reject) => {
        http.post("/common-web/approve/batchCreateApproveProcess", params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 获取当前审批人的列表
 * */
const getAuditUserListService = (params) => {
    return new Promise((resolve, reject) => {
        http.post("/common-web/approve/getAuditUserList", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 撤回审批对象
 * */
const recallApproveProcessService = (params) => {
    return new Promise((resolve, reject) => {
        http.post("/common-web/approve/recall", params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/**
 * 导出历史工程事前成本工程列表
 * */
const frontHistoryExportService = (params) => {
    return new Promise((resolve, reject) => {
        http.post("/contract-web/project/front/history/export", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}


/**
 * 导出工程事前成本列表
 * */
const frontExportService = (params) => {
    return new Promise((resolve, reject) => {
        http.post("/contract-web/project/front/export", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/**
 * 查询事前工程量清单细目
 * */
const queryBeforeDataService = (params) => {
    return new Promise((resolve, reject) => {
        http.get("/contract-web/project/front/generalItem/list", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/**
 * 新增事中工程量清单细目
 * */
const addBeforeDataService = (params) => {
    return new Promise((resolve, reject) => {
        http.post("/contract-web/project/front/generalItem/add?projectId="+params.projectId, params.voList, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 查询事前成本列表合计
 * */
const queryBeforeListTotalService = (params) => {
    return new Promise((resolve, reject) => {
        http.get("/contract-web/project/front/project/listTotal", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

//--------事中接口----------
/**
 * 查询事中工程量清单细目
 * */
const queryMiddleDataService = (params) => {
    return new Promise((resolve, reject) => {
        http.get("/contract-web/project/middle/queryMiddleData", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 基础数据-获取工程量清单列表
 * */
const queryProjectDetailsService = (params) => {
    return new Promise((resolve, reject) => {
        http.post("/contract-web/common/dict/projectDetails", params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/**
 * 新增事中工程量清单细目
 * */
const addMiddleDataService = (params) => {
    return new Promise((resolve, reject) => {
        http.post("/contract-web/project/middle/addMiddleData", params.voList, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 查询事前成本历史列表
 * */
const queryMiddleListService = (params) => {
    return new Promise((resolve, reject) => {
        http.get("/contract-web/project/middle/list", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 新增事中成本细目
 * */
const inTheFrontItemService = (params) => {
    return new Promise((resolve, reject) => {
        http.post("/contract-web/project/middle/items", params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/**
 * 查询事中成本详情
 * */
const queryMiddleDetailService = (params) => {
    return new Promise((resolve, reject) => {
        http.get("/contract-web/project/middle/detail", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/**
 * 批量删除事中工程量清单细目
 * */
const batchDeleteMiddleDataService = (params) => {
    return new Promise((resolve, reject) => {
        http.post("/contract-web/project/middle/batchDeleteMiddleData", params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 删除事中成本细目
 * */
const deleteMiddleItemsService = (params) => {
    return new Promise((resolve, reject) => {
        http.delete("/contract-web/project/middle/items", params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 更新事前成本细目
 * */
const saveMiddleService = (params) => {
    return new Promise((resolve, reject) => {
        http.put("/contract-web/project/middle", params).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}/**
 * 更新批量事前成本细目
 * */
const saveMiddleBatchService = (params) => {
    return new Promise((resolve, reject) => {
        http.put("/contract-web/project/middle/updateMiddleBatch", params).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 查询事中成本历史列表
 * */
const getMiddleHistroyService = (params) => {
    return new Promise((resolve, reject) => {
        http.get("/contract-web/project/middle/historyList", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 查询事中成本列表合计
 * */
const getMiddleListTotalService = (params) => {
    return new Promise((resolve, reject) => {
        http.get("/contract-web/project/middle/listTotal", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 查询有效供应商列表
 * */
const getSupplierValidListService = (params) => {
    return new Promise((resolve, reject) => {
        http.get("/supplier-web/supplier/valid/list", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 根据乙方id，项目id获取分项合同列表
 * */
const querySubInfoByPartyBIdProjectIdService = (params) => {
    return new Promise((resolve, reject) => {
        http.get("/contract-web/sub/contract/querySubInfoByPartyBIdProjectId", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 导出成本支出统计表
 * */
const exportMiddleService = (params) => {
    return new Promise((resolve, reject) => {
        http.post("/contract-web/project/middle/export/exportMiddle", params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 导出事中历史版本
 * */
const exportMiddleHistoryService = (params) => {
    return new Promise((resolve, reject) => {
        http.post("/contract-web/project/middle/export/exportMiddleHistory", params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}




/**
 * 成本支出汇总表
 * */
const getCostGatherTableService = (params) => {
    return new Promise((resolve, reject) => {
        http.get("/contract-web/project/middle/costGatherTable", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 设置成本支出汇总表
 * */
const setCostGatherTableService = (params) => {
    return new Promise((resolve, reject) => {
        http.post("/contract-web/project/middle/setCostGatherTable", params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/**
 * 工程结算单
 * */
const getProjectSettleService = (params) => {
    return new Promise((resolve, reject) => {
        http.get("/contract-web/project/middle/projectSettle", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/**
 * 导出成本支出统计表
 * */
const projectSettleExportService = (params) => {
    return new Promise((resolve, reject) => {
        http.get("/contract-web/project/middle/projectSettle/export", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/**
 * 导出成本支出汇总表
 * */
const costGatherTableService = (params) => {
    return new Promise((resolve, reject) => {
        http.post("/contract-web/project/middle/export/costGatherTable", params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/**
 * 成本支出统计表
 * */
const getCostAnalysisTableService = (params) => {
    return new Promise((resolve, reject) => {
        http.get("/contract-web/project/middle/costAnalysisTable", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 设置成本支出统计表
 * */
const setCostAnalysisTableService = (params) => {
    return new Promise((resolve, reject) => {
        http.post("/contract-web/project/middle/setCostAnalysisTable", params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/**
 * 导出成本支出统计表
 * */
const costAnalysisTableService = (params) => {
    return new Promise((resolve, reject) => {
        http.post("/contract-web/project/middle/export/costAnalysisTable", params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}


/**
 * 成本支出统计表
 * */
const queryCurrentApproveProcessService = (params) => {
    return new Promise((resolve, reject) => {
        http.get("/common-web/approve/queryCurrentApproveProcess", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 提交审批
 * */
const submitApproveProcessService = (params) => {
    return new Promise((resolve, reject) => {
        http.post("/common-web/approve/submitApproveProcess", params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 获取事前总包部分模板
 * */
const getFrontImportTemplateService = (params) => {
    return new Promise((resolve, reject) => {
        http.get("/contract-web/project/front/import/getFrontImportTemplate", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 获取事前目标成本部分模板
 * */
const getFrontItemsImportTemplateService = (params) => {
    return new Promise((resolve, reject) => {
        http.get("/contract-web/project/front/import/getFrontItemsImportTemplate", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}




/**
 * 获取事中总包部分模板
 * */
const getMiddleImportTemplateService = (params) => {
    return new Promise((resolve, reject) => {
        http.get("/contract-web/project/middle/import/getMiddleImportTemplate", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/**
 * 获取事中预计部分模板
 * */
const getMiddleExpectImportTemplateService = (params) => {
    return new Promise((resolve, reject) => {
        http.get("/contract-web/project/middle/import/getMiddleExpectImportTemplate", params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 获取事中实际部分模板
 * */
const getMiddleActImportTemplateService = (params) => {
    return new Promise((resolve, reject) => {
        http.get("/contract-web/project/middle/import/getMiddleActImportTemplate", params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/**
 * 确认导入事中总包部分
 * */
const doImportMiddleDataService = (params) => {
    return new Promise((resolve, reject) => {
        http.post("/contract-web/project/middle/import/doImportMiddleData", params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/**
 * 确认导入事中预计部分
 * */
const doImportMiddleExpectDataService = (params) => {
    return new Promise((resolve, reject) => {
        http.post("/contract-web/project/middle/import/doImportMiddleExpectData", params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/**
 * 确认导入事中实际部分
 * */
const doImportMiddleActDataService = (params) => {
    return new Promise((resolve, reject) => {
        http.post("/contract-web/project/middle/import/doImportMiddleActData", params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}


/**
 * 查询零星工程量列表
 * */
const getSporadicListService = (params) => {
    return new Promise((resolve, reject) => {
        http.get("/contract-web/sporadic/project/list", params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 查询审批通过的项目列表
 * */
const getAllProjectPassListService = (params) => {
    return new Promise((resolve, reject) => {
        http.get("/contract-web/project/queryAllProjectWithAuth", params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 获取提报部门列表
 * */
const queryApplyDeptListService = (params) => {
    return new Promise((resolve, reject) => {
        http.get("/contract-web/sporadic/project/queryApplyDeptList", params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}



/**
 * 新增零星工程量
 * */
const addSporadicProjectService = (params) => {
    return new Promise((resolve, reject) => {
        http.post("/contract-web/sporadic/project/addSporadicProject", params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 审批通过后，上传附件
 * */
const insertItemsAfterAuditService = (params) => {
    return new Promise((resolve, reject) => {
        http.post("/contract-web/sporadic/project/insertItemsAfterAudit", params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 更新零星工程量
 * */
const modifySporadicProjectService = (params) => {
    return new Promise((resolve, reject) => {
        http.put("/contract-web/sporadic/project", params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/**
 * 查询特定零星工程量
 * */
const getSporadicProjectInfoService = (params) => {
    return new Promise((resolve, reject) => {
        http.get("/contract-web/sporadic/project", params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 删除零星工程量
 * */
const deleteSporadicProjectService = (params) => {
    return new Promise((resolve, reject) => {
        http.delete("/contract-web/sporadic/project", params).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}


/**
 * 导出选定条目
 * */
const exportSporadicProjectService = (params) => {
    return new Promise((resolve, reject) => {
        http.get("/contract-web/sporadic/project/export", params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 导出全部条目
 * */
const exportAllSporadicProjectService = (params) => {
    return new Promise((resolve, reject) => {
        http.get("/contract-web/sporadic/project/export/all", params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/**
 * 事中实际细目更新合同id
 * */
const updateActItemSubContractId = (params) => {
    return new Promise((resolve, reject) => {
        http.post("/contract-web/project/middle/updateActItemSubContractId", params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
export {
    getDeptListService,
    getBefireListService,
    queryDetailDataService,
    beforFrontItemService,
    queryFrontDetailService,
    batchDeleteFrontDataService,
    deleteFrontItemsService,
    saveFrontService,
    saveFrontBatchService,
    getFrontHistroyService,
    queryApproveProcessService,
    createApproveProcessService,
    batchCreateApproveProcessService,
    getAuditUserListService,
    recallApproveProcessService,
    frontHistoryExportService,
    frontExportService,
    queryBeforeDataService,
    addBeforeDataService,
    queryBeforeListTotalService,

    queryMiddleDataService,
    queryProjectDetailsService,
    addMiddleDataService,
    queryMiddleListService,
    inTheFrontItemService,
    queryMiddleDetailService,
    deleteMiddleItemsService,
    saveMiddleService,
    saveMiddleBatchService,
    getMiddleHistroyService,
    getMiddleListTotalService,
    getSupplierValidListService,
    querySubInfoByPartyBIdProjectIdService,
    exportMiddleService,
    exportMiddleHistoryService,
    queryMiddleAuditListService,

    getCostGatherTableService,
    setCostGatherTableService,
    costGatherTableService,
    getCostAnalysisTableService,
    setCostAnalysisTableService,
    costAnalysisTableService,

    queryCurrentApproveProcessService,
    submitApproveProcessService,

    getProjectSettleService,
    projectSettleExportService,

    getFrontImportTemplateService,
    getFrontItemsImportTemplateService,

    getMiddleImportTemplateService,
    getMiddleExpectImportTemplateService,
    getMiddleActImportTemplateService,
    doImportMiddleDataService,
    doImportMiddleExpectDataService,
    doImportMiddleActDataService,


    getSporadicListService,
    getAllProjectPassListService,
    queryApplyDeptListService,
    addSporadicProjectService,
    insertItemsAfterAuditService,
    modifySporadicProjectService,
    getSporadicProjectInfoService,
    deleteSporadicProjectService,
    exportSporadicProjectService,
    exportAllSporadicProjectService,
    batchDeleteMiddleDataService,

    updateActItemSubContractId
}
